export { default as UsuarioConfirmacao } from './UsuarioConfirmacao';
export { default as ResetPassword } from './ResetPassword';



// WEBPACK FOOTER //
// ./src/features/pages/index.js